<footer>
  <p>&copy; Copyright 2018. All rights reserved.</p>
</footer>